var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classObject},[_c('b',[_vm._v(_vm._s(_vm.displayName))]),_c('i',[_vm._v(_vm._s(_vm.description))]),_vm._v(" "+_vm._s(_vm.timeDisplay)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }